import { UserRole } from '@business/entities/account';
import { PrivateRoute, PublicRoute, Router, Switch } from '@core/router';
import React, { lazy, memo } from 'react';

const LoginPage = lazy(() => import('@modules/auth/LoginPage'));
const ResetPasswordPage = lazy(() => import('@modules/auth/ResetPasswordPage'));
const CreatePasswordPage = lazy(() => import('@modules/auth/CreatePasswordPage'));
const ActivateAccountPage = lazy(() => import('@modules/auth/ActivateAccountPage'));
const ControlAccount = lazy(() => import('@modules/auth/ControlAccount'));
const NotFroundPage = lazy(() => import('@modules/pages/NotFroundPage'));
const UnauthorizedPage = lazy(() => import('@modules/pages/UnauthorizedPage'));
const MainPage = lazy(() => import('@modules/main'));
const CourseBuilderPreviewPage = lazy(() => import('@modules/course/CourseBuilder/CourseBuilderPreviewPage'));
const ControlAccountByEmail = lazy(() => import('@modules/auth/ControlAccountByEmail'));
const ViewStatCollectionFormPage = lazy(
  () => import('@modules/statistics/StatCollection/StatCollection/AddEditStatFormTab/ViewStatCollectionFormPage'),
);
const FullScreenDetailsPage = lazy(() => import('@modules/OrgBoard/FullScreenDetailsPage'));
const FullscreenOrgBoardPage = lazy(() => import('@modules/OrgBoard/FullscreenOrgBoardPage'));
const PrintOrgBoardPage = lazy(() => import('@modules/OrgBoard/PrintOrgBoardPage'));
const GraphPrintPage = lazy(() => import('@modules/statistics/graphs/GraphPrintPage'));
const GraphsPrintPage = lazy(() => import('@modules/statistics/graphs/GraphsPrintPage'));

const PrintAdminScalePage = lazy(() => import('@modules/adminscale/PrintAdminScalePage'));
const ViewProgramPrintPage = lazy(() => import('@modules/programs/ProgramPrintPage'));
const BattlePlanPrintPage = lazy(() => import('@modules/battlePlan/BattlePlanPrintPage'));
const BattlePlanCompletedTaskPrintPage = lazy(() => import('@modules/battlePlan/BattlePlanCompletedTaskPrintPage'));
const BattlePlanProgramPrintPage = lazy(() => import('@modules/battlePlan/BattlePlanProgramPrintPage'));

const knowledgeBasePage = lazy(() => import('@modules/knowledgeBase/knowledgeBasePage'));
const KnowledgeBaseView = lazy(() => import('@modules/knowledgeBase/KnowledgeBaseView'));
const KbSearchPage = lazy(() => import('@modules/knowledgeBase/KbSearchPage'));

import { Route } from 'react-router-dom';

export const AppRouter = memo(() => (
  <div>
    <Router>
      <Switch>
        {/* end public routes moved from public router */}
        <PublicRoute exact path="/login" component={LoginPage} />
        <PrivateRoute exact path="/courses/lesson/preview/:id" component={CourseBuilderPreviewPage} roles={[UserRole.admin, UserRole.user]} />

        <PublicRoute exact path="/stat-collection/view-form/:id" component={ViewStatCollectionFormPage} />

        <PublicRoute exact path="/reset-password" component={ResetPasswordPage} />
        <PublicRoute exact path="/create-password" component={CreatePasswordPage} />

        <PublicRoute exact path="/activate/:token" component={ActivateAccountPage} />
        <PublicRoute exact path="/control-account/:appId" component={ControlAccount} />
        <PublicRoute exact path="/activate/:appId/:token" component={ActivateAccountPage} />
        <PublicRoute exact path="/control-account/:appId/:email?" component={ControlAccount} />
        <PublicRoute exact path="/control-account-by-email/:appId/:email?" component={ControlAccountByEmail} />

        <PublicRoute exact path="/org-board/fullscreen" component={FullscreenOrgBoardPage} />
        <PublicRoute exact path="/org-board/fullscreen/details/:id" component={FullScreenDetailsPage} />
        <PublicRoute exact path="/org-board/print" component={PrintOrgBoardPage} />
        <PublicRoute exact path="/graphs/print-graph-pdf" component={GraphPrintPage} />
        <PublicRoute exact path="/graphs/print-graphs-pdf" component={GraphsPrintPage} />

        <PublicRoute exact path="/admin-scale/print/:id" component={PrintAdminScalePage} />

        <PrivateRoute exact path="/programs/print/:id" component={ViewProgramPrintPage} />

        <PrivateRoute exact path="/battle-plan/print/:id" component={BattlePlanPrintPage} />
        <PrivateRoute exact path="/battle-plan/task-print/:id" component={BattlePlanCompletedTaskPrintPage} />
        <PrivateRoute exact path="/battle-plan/program-print/:id" component={BattlePlanProgramPrintPage} />

        {/* Kowledge Base */}
        <PublicRoute exact path="/kb/search" component={KbSearchPage} />
        <PublicRoute exact path="/kb/view/:id/:slug?" component={KnowledgeBaseView} />
        <PublicRoute exact path="/kb/:id?" component={knowledgeBasePage} />

        <PrivateRoute path="/" component={MainPage} />
        <Route component={NotFroundPage} />
      </Switch>
    </Router>
  </div>
));
